
import { Select, Option, Input } from "element-ui"
import { uniqBy } from "lodash"
import { getStoreRegions } from "@/api/delivery"
import { FILTER_KEY } from "@/constants/storeLocator"

export default {
  name: "StoreLocatorFilter",
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Input.name]: Input
  },
  props: {
    servicesOptions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      filter: {
        search: "",
        district: "",
        area: "",
        services: ""
      },
      districtOptions: [],
      allOptions: [],
      FILTER_KEY
    }
  },
  computed: {
    areaOptions() {
      return this.allOptions
        .filter(item => {
          if (this.filter.district.length === 0) return true
          return this.filter.district == item.municipal
        })
        .map(item => ({
          label: item.districtName,
          value: item.district
        }))
    }
  },
  watch: {
    filter: {
      handler(val) {
        this.$emit("change", val)
      },
      deep: true
    }
  },
  mounted() {
    this.getRegionOptions()
  },
  methods: {
    async getRegionOptions() {
      try {
        const { data: res } = await getStoreRegions()
        this.allOptions = res || []
        this.districtOptions = uniqBy(this.allOptions, "municipal").map(item => ({
          label: item.municipalName,
          value: item.municipal
        }))
      } catch (error) {
        console.log(error)
      }
    },
    handleChanged(key, value) {
      if (key === FILTER_KEY.DISTRICT) {
        this.filter.area = ""
      }
      this.filter[key] = value
    },
    isActiveDistrict(item) {
      return this.filter.district === item.value
    },
    isActiveArea(item) {
      return this.filter.area === item.value
    },
    isActiveServices(item) {
      return this.filter.services === item.value
    }
  }
}
